import { trackEvent } from "../services/analyticsService";
import { isAccessLimitedByParentalLevel } from "../services/parentalControlService";
import { routes } from "../routes/index";
import { getAppState } from "../state";
import getDurationFromVoucher from "../utils/getDurationFromVoucher";

const PAYLOAD = "PAYLOAD";
const SCOUPONCODE = "SCOUPONCODE";
const MONTH = "MONTH";

function goToDetailPage(titleId, category) {
  trackEvent("eden", "eden wakeup", titleId);
  const section = getSectionFromDeepLinkObject(category);
  const kidsPath = isAccessLimitedByParentalLevel() ? routes.kids : "";
  this.history.push(`${kidsPath}/${section}/${titleId}`, {
    deepLinkReferrer: true
  });
}

function goToVoucherFlow(key, value) {
  const data = {
    duration: {
      duration: key === MONTH ? value : getDurationFromVoucher(value),
      unit: key === MONTH ? MONTH[0] : value[0].toUpperCase()
    },
    voucher_code: key === MONTH ? null : value,
    checkEligibility: key === MONTH,
    autoRedeem: true,
    isEvoucher: true
  };
  if (key === SCOUPONCODE) {
    getAppState().sCouponCode = value;
  }
  getAppState().voucherData = data;

  this.history.push(routes.landing);
}

// TODO Describe that this needs to have history object in this to work
/**
 * This service has the responsibility to act to deep link navigation requests. For now it's just a navigator to the
 * page the deep link action requested but in the future it will be more complex providing options like playing content
 * directly.
 * @param {Object} deepLinkAction Object containing information about the action to be performed in response to the
 * requested deep linking action. Properties this object can have:
 * - category: series|movies
 * - titleId: number
 * - seasonNumber: number,
 * - episodeNumber: number,
 * - play: boolean
 * - sectionId\": ""
 * - lang: en|ar|fr
 */
export function executeDeepLinkAction(deepLinkAction) {
  const { titleId, category, key, value } = deepLinkAction;
  if (key === PAYLOAD) {
    goToDetailPage.call(this, titleId, category);
  } else if (key === SCOUPONCODE || key === MONTH) {
    goToVoucherFlow.call(this, key, value);
  } else {
    this.history.push(routes.home, {
      deepLinkReferrer: false
    });
  }
}

function getSectionFromDeepLinkObject(category) {
  const sections = {
    series: "series",
    movie: "movies"
  };
  return sections[category];
}
